import { Component } from '@angular/core';
import { GraphResult } from '@models/graph';
import { ReportsService } from '@services/reports.service';
import { ChartConfiguration, ChartData } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';

export class BaseGraphComponent {
  public hexadecimalColors: string[] = [];
  public hasData: boolean = false;

  public pieChartOptions: ChartConfiguration<"pie">["options"] = {
    aspectRatio: 1,
    plugins: {
      legend: {
        labels: { filter: (_) => false },
        display: false,
      },
    },
    responsive: false,
  };

  public pieChartData: ChartData<"pie"> = {
    labels: [],
    datasets: [
      {
        data: [],
        borderJoinStyle: "miter",
        borderWidth: 0,
        backgroundColor: [],
      },
    ],
  };

  public constructor(
    protected readonly reportsService: ReportsService,
    pieColor: PrimitiveValueWrapper<string[]>
  ) {
    this.hexadecimalColors = pieColor.value;
  }


  protected updatePieChartData(
    data: GraphResult[],
    chart: BaseChartDirective
  ) {
    let difference = chart.data.labels.filter(
      (label: string) =>
        !data.map((feature) => feature.description).includes(label)
    );

    difference.forEach((description) => {
      const labelIndex = chart.data.labels.findIndex((x) => x == description);
      (chart.data.datasets[0].backgroundColor as any[]).splice(labelIndex, 1);
      chart.data.datasets[0].data.splice(labelIndex, 1);
      chart.data.labels.splice(labelIndex, 1);
    });

    //Allow Soft Animation when changing data
    for (let i = 0; i < data.length; i++) {
      const dataIndex = chart.data.labels.indexOf(data[i].description);
      if (dataIndex == -1) {
        chart.data.labels.push(data[i].description);
        chart.data.datasets[0].data.push(data[i].count);
        (chart.data.datasets[0].backgroundColor as any[]).push(
          this.hexadecimalColors[i]
        );
      } else {
        chart.data.labels[dataIndex] = data[i].description;
        chart.data.datasets[0].data[dataIndex] = data[i].count;
        chart.data.datasets[0].backgroundColor[dataIndex] =
          this.hexadecimalColors[i];
      }
    }

    this.sortPieData(chart.data as any);
    chart.update();
  }

  protected getLabels(
    data: GraphResult[],
    colors: string[]
  ): { name: string; color: string; count: number }[] {
    const labels = [];
    for (let i = 0; i < data.length; i++) {
      labels.push({
        name: data[i].description,
        color: colors[i],
        count: data[i].count,
      });
    }

    return labels;
  }

  private sortPieData(data: any): GraphResult[] {
    for (let i = 0; i < data.datasets[0].data.length; i++) {
      for (let j = 0; j < data.datasets[0].data.length - i - 1; j++) {
        if (data.datasets[0].data[j] < data.datasets[0].data[j + 1]) {
          const value = data.datasets[0].data[j];
          const color = data.datasets[0].backgroundColor[j];
          const label = data.labels[j];

          data.datasets[0].data[j] = data.datasets[0].data[j + 1];
          data.datasets[0].backgroundColor[j] =
            data.datasets[0].backgroundColor[j + 1];
          data.labels[j] = data.labels[j + 1];

          data.datasets[0].data[j + 1] = value;
          data.datasets[0].backgroundColor[j + 1] = color;
          data.labels[j + 1] = label;
        }
      }
    }

    return data;
  }
}


class PrimitiveValueWrapper<T> {
  public value: T;
}
